/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Wizard_Tools_HintInputs */



/**
* | output |
* | --- |
* | "This is what the assistant will be able to do." |
*
* @param {My_Integrations_Wizard_Tools_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_wizard_tools_hint = /** @type {((inputs?: My_Integrations_Wizard_Tools_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Wizard_Tools_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das kann der Assistent damit tun.")
	return /** @type {LocalizedString} */ ("This is what the assistant will be able to do.")
});